import { render, staticRenderFns } from "./BookerPayments.vue?vue&type=template&id=10e17cd8"
import script from "./BookerPayments.vue?vue&type=script&lang=js"
export * from "./BookerPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports